import React from 'react';

const Hero = () => {
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    if (targetId) {
      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>简单美味，日常好菜</h1>
          <p>发现让烹饪变得简单又愉快的美味食谱，从快捷晚餐到周末大餐，这里都有。</p>
          <div className="hero-buttons">
            <a href="#recipes" className="btn btn-primary" onClick={(e) => handleNavClick(e, '#recipes')}>浏览食谱</a>
            <a href="#" className="btn btn-secondary" onClick={(e) => handleNavClick(e, null)}>了解更多</a>
          </div>
        </div>
      </div>
      <div className="hero-image">
        <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=80" alt="新鲜食材" />
      </div>
    </section>
  );
};

export default Hero;
